<template>
  <div id="certify">
		<div class="swiper-container">
			<div class="swiper-wrapper">
				<div class="swiper-slide"><img src="http://img1.anyew.cn/book/0/43/10043_bg.jpg" alt="凶棺" class="book-cover"></div>
				<div class="swiper-slide"><img src="http://img1.anyew.cn/book/0/328/10328_fq.jpg" alt="民间风水奇谭" class="book-cover"></div>
				<div class="swiper-slide"><img src="http://img1.anyew.cn/book/0/109/10109_ar.jpg" title="麻衣鬼相" alt="麻衣鬼相"></div>
				<div class="swiper-slide"><img src="http://img1.anyew.cn/book/0/204/10204_av.jpg" title="家有妖妻" alt="家有妖妻"></div>
				<div class="swiper-slide"><img src="http://img1.anyew.cn/book/0/1855/11855_xy.jpg" title="冥媒正娶" alt="冥媒正娶"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: 'HelloWorld',
  data () {
    return {
      
    }
  },
  mounted() {
     var certifySwiper = new Swiper('#certify .swiper-container', {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            
        },
        on: {
            progress: function(progress) {
                for (var i = 0; i < this.slides.length; i++) {
                    var slide = this.slides.eq(i);
                    var slideProgress = this.slides[i].progress;
                    var modify = 1;
                    if (Math.abs(slideProgress) > 1) {
                        modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                    }
                    var translate = slideProgress * modify * 80 + 'px';
                    var scale = 1 - Math.abs(slideProgress) / 5;
                    var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                    slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                    slide.css('zIndex', zIndex);
                    slide.css('opacity', 1);
                    if (Math.abs(slideProgress) > 3) {
                        slide.css('opacity', 0);
                    }
                }
            },
            setTransition: function(transition) {
                for (var i = 0; i < this.slides.length; i++) {
                    var slide = this.slides.eq(i)
                    slide.transition(transition);
                }

            }
        }

    }) 
  },
}
</script>
<style scoped>
@import url("../assets/css/swiper.min.css");
@import url("../assets/css/certify.css");
</style>



// WEBPACK FOOTER //
// src/components/ZwSwiper.vue